import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import { createRef } from 'react';
import App from './App';
import { WSProvider } from './contexts/WebSocketContext';
import './index.css';

const notistackRef = createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current?.closeSnackbar(key);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <WSProvider>
      <SnackbarProvider
        ref={notistackRef}
        action={(key) => (
          <IconButton color="inherit" onClick={onClickDismiss(key)}>
            <Close />
          </IconButton>
        )}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        maxSnack={3}
      >
        <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
          <App />
        </BrowserRouter>
      </SnackbarProvider>
    </WSProvider>
  </HelmetProvider>
);
